<template>
  <div class="walletset-panel">
    <el-breadcrumb separator=">" class="bc-nav">
      <el-breadcrumb-item> <i class="iconfont icon_home icon-t-1"></i>钱包设置</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="segment-outer">
      <div class="segment mt-10">
        <div class="segment-header">账户支付密码</div>
        <div class="segment-area" id="auto-0">
          <div v-if="isSetting" class="setting-pwdbox">
            <i class="el-icon-circle-check font-size20 font-green icon-t2 pr-10"></i>支付密码
            <span class="font-green ml-10">已设置</span>
            <p class="settip">保护账户财产安全，请设置一个与登录密码不同的支付密码</p>
          </div>
          <div v-else class="setting-pwdbox">
            <i class="el-icon-information font-size20 font-red icon-t2 pr-10"></i>支付密码
            <span class="font-red ml-10">未设置</span>
            <p class="settip">保护账户财产安全，请设置一个与登录密码不同的支付密码</p>
          </div>
        </div>
        <div class="segment-foot" id="auto-1">
          <div v-if="isSetting">
            <router-link :to="{ path: '/pwdcontrol/edit' }">
              <el-button type="primary" size="small" class="ml-20 mr-10">修改支付密码</el-button>
            </router-link>
            <el-button size="small" @click="toForgetPwdcontrol" class="ml-10">忘记密码</el-button>
          </div>
          <div v-else id="auto-2">
            <el-button type="primary" size="small" @click="toSetPwdcontrol" class="ml-20 mr-10">设置支付密码</el-button>
          </div>
        </div>
      </div>
    </div>
    <div class="segment-outer">
      <div class="segment statistics mt-10">
        <div class="segment-header">账户余额提醒</div>
        <div class="segment-area">
          <div class="setting-yuebox">
            <el-row>
              <el-col :span="12">
                <div v-if="balanceAlert.isOpen == 1" id="auto-3">
                  <i class="el-icon-circle-check font-size20 font-green icon-t2 pr-10"></i>钱包余额提醒
                  <span class="font-green ml-10">已开启</span>
                  <p v-if="balanceAlert.money != ''" class="settip">
                    阀值：
                    <span class="font-green">{{ balanceAlert.money | thousands(2) }} 元</span>
                  </p>
                </div>
                <div v-else id="auto-4">
                  <i class="el-icon-information font-size20 font-red icon-t2 pr-10"></i>钱包余额提醒
                  <span class="font-red ml-10">未开启</span>
                </div>
              </el-col>
              <el-col :span="12">
                <div v-if="JSON.stringify(actpAlert) !== '{}'">
                  <div v-if="actpAlert.isOpen == 1" id="auto-5">
                    <i class="el-icon-circle-check font-size20 font-green icon-t2 pr-10"></i>账期余额提醒
                    <span class="font-green ml-10">已开启</span>
                    <p v-if="actpAlert.money != ''" class="settip">
                      阀值：
                      <span class="font-green">{{ actpAlert.money | thousands(2) }} 元</span>
                    </p>
                  </div>
                  <div v-else id="auto-6">
                    <i class="el-icon-information font-size20 font-red icon-t2 pr-10"></i>账期余额提醒
                    <span class="font-red ml-10">未开启</span>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="segment-foot" id="auto-7">
          <router-link :to="{ path: '/reminder/balance' }" class="ml-10">
            <el-button type="primary" size="small">设置钱包余额提醒</el-button>
          </router-link>
          <router-link v-if="JSON.stringify(actpAlert) !== '{}'" :to="{ path: '/reminder/actp' }" class="ml-10">
            <el-button size="small">设置账期余额提醒</el-button>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 自动化测试id
 * 当前最大值为:7
 * @param {int} max id最大值
 * 每次变更累加 请手动更新
 * 示例：auto-0
 */
import { WUYI } from '@/api/common';
import axios from '@/api/axiosNew';
import api from '@/api/base.new.api';
import { commonEventTracking } from '@/utils';
export default {
  name: 'WalletSet',
  data: function () {
    return {
      isSetting: false,
      balanceAlert: {},
      actpAlert: {}
    };
  },
  created: function () {
    // 是否设置了支付密码
    this.checkPassword();
    // 查 钱包/账期余额提醒
    this.getData();
    commonEventTracking('ntoccCmyWebWalletSettings', 'page', 'pltUserBehavior');
  },
  methods: {
    async getData() {
      let res = await axios.post(api.getWalletAlertData, { type: 0 });
      this.balanceAlert = res.data.find(item => item.type == 1) || {};
      this.actpAlert = res.data.find(item => item.type == 2) || {};
    },
    pwdSetting: function (model) {
      var topath = '/pwdcontrol/' + model;
      this.$router.push({ path: topath });
    },
    async checkPassword() {
      let res = await axios.post(api.queryAccountPasswordSetting);
      this.isSetting = res.data;
    },
    toSetPwdcontrol() {
      let accounttype = WUYI.currentData.user.accounttype;
      if (accounttype == 2) {
        this.$message.warning('非手机号账户不支持设置密码，请联系主账号');
        return;
      }
      window.open('wallet.html#/pwdcontrol/set');
    },
    toForgetPwdcontrol() {
      let accounttype = WUYI.currentData.user.accounttype;
      if (accounttype == 2) {
        this.$message.warning('非手机号账户不支持找回密码，请联系主账号');
        return;
      }
      window.open('wallet.html#/pwdcontrol/forget');
    }
  }
};
</script>
